export default "__VITE_ASSET__moOP$fNx__"